import Sidebar from '../utill/Sidebar'
import Header from "../utill/Header";
import Footer from "../utill/Footer";
import {Card, Form, Table} from "react-bootstrap";
import React, {ChangeEvent, useContext, useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import axios from "axios";
import Url from "../utill/Url";
import {useSelector} from "react-redux";
import {AesEncrypt, reissue} from "../utill/UtilComponent";
import styles from "../../css/Authority.module.css";
import {RootState} from "../../redux/store";
import passwordValid from "../utill/passwordValid";
import { MESSAGES } from "../utill/Messages";

function WebUserAdd() {
    const url = useContext(Url)
    const navigate = useNavigate();
    const nowUser = useSelector((state: RootState) => state.user.value);
    const [user, setUser] = useState({
        userId: '',
        password: '',
        userName: ''
    });
    let userId = nowUser.id;
    const [idError, setIdError] = useState('');
    const [isIdAvailable, setIsIdAvailable] = useState(false);
    const [passwdCheck, setPasswdCheck] = useState('');
    const [disabled, setDisabled] = useState(false);
    const [pwSuccess, setPwSuccess] = useState(false);
    const [message, setMessage] = useState({text: '', color: ''});
    const [error, setError] = useState('');
    const [customerCode, setCustomerCode] = useState<CustomerCode[]>([]);
    const [customerCodeSelected, setCustomerCodeSelected] = useState("");
    const [authority, setAuthority] = useState<AuthorityName[]>([]);
    const [authoritySelected, setAuthoritySelected] = useState("");
    const auth = useSelector((state: RootState) => state.loginAuth.value);

    useEffect(() => {
        document.title = 'Mcon 모니터링 시스템-웹계정 등록'
        if (auth.MENUAUTH?.SET0300?.readAuthorityYn !== "1" && auth.MENUAUTH?.SET0300?.writeAuthorityYn !== "1") {
            alert('페이지를 볼 수 있는 권한이 없습니다.');
            navigate(auth.firstUrl);
        }
        else if (auth.MENUAUTH?.SET0300?.writeAuthorityYn !== "1") {
            alert('페이지를 볼 수 있는 권한이 없습니다.');
            navigate('/WebUserManagement');
        }
        reissue(userId, url, navigate).then(() => {
            axios.get(url + 'customercode/findall', {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            }).then((response) => {
                setCustomerCode(response.data.result.data)
                setCustomerCodeSelected(response.data.result.data[0].customerCode)
            })
            axios.get(url + 'authority/findall', {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            }).then((response) => {
                setAuthority(response.data.result.data)
                setAuthoritySelected(response.data.result.data[0].authorityId)
            })
        });
    }, []);

    const handleSubmit = async (e: React.MouseEvent<HTMLButtonElement>) => {
        reissue(userId, url, navigate).then(() => {
            e.preventDefault();
            if (!user.userId || !user.password) {
                alert('아이디와 비밀번호는 필수 입력 항목입니다.');
                return;
            } else if (!isIdAvailable) {
                alert('아이디의 중복확인이 필요합니다');
                return;
            }
            const isAction = window.confirm('등록 하시겠습니까?');
            if (isAction) {
                try {
                    axios.post(url + 'admin/create', {
                        userId: user.userId,
                        password: AesEncrypt(user.password),
                        userName: user.userName,
                        customerCode: customerCodeSelected,
                        authorityId: authoritySelected,
                        loginId: nowUser.id
                    }, {
                        headers: {
                            'Authorization': localStorage.getItem('Authorization')
                        }
                    }).then((e) => {
                            alert('웹 계정 등록 완료');
                            navigate('/WebUserManagement');
                        }
                    )
                } catch (e) {
                    console.error(e);
                }
            }
        })
    };

    const handleIdChange = (e: ChangeEvent<HTMLInputElement>) => {
        setUser({...user, [e.target.name]: e.target.value});
        setIdError('');
        setIsIdAvailable(false);
    };

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;

        if (name === 'password') {
            if (value === '') {
                setError('');
                setPwSuccess(false);
            } else {
                if (passwordValid(value)) {
                    setError('');
                    setPwSuccess(true);
                } else {
                    setError(MESSAGES.PASSWORD.INVALID);
                    setPwSuccess(false);
                }
            }
        }

        setUser(prev => ({ ...prev, [name]: value }));
    };

    const handlePasswdCheckChange = (e: ChangeEvent<HTMLInputElement>) => {
        setPasswdCheck(e.target.value);
    };

    const handleChangeAuthoritySelect = (e: ChangeEvent<HTMLSelectElement>) => {
        setAuthoritySelected(e.target.value)
    }

    const handleChangeCustomerCodeSelect = (e: ChangeEvent<HTMLSelectElement>) => {
        setCustomerCodeSelected(e.target.value)
    }

    const handleCancel = () => {
        const Cancel = window.confirm('취소하시겠습니까? 입력중인 내용이 모두 삭제됩니다.');
        if (Cancel) {
            navigate('/WebUserManagement');
        }
    }

    useEffect(() => {
        if ((user.password !== passwdCheck) || !passwordValid(user.password)) {
            setMessage({text: MESSAGES.PASSWORD.MISMATCH, color: "red"});
            setPwSuccess(false);
        } else if (user.password === passwdCheck) {
            setMessage({text: MESSAGES.PASSWORD.CORRECT, color: 'green'});
            setPwSuccess(true);
        }
        if (!user.password && !passwdCheck) {
            setMessage({text: '', color: ''});
        }
    }, [user.password, passwdCheck]);

    useEffect(() => {
        setDisabled(!(pwSuccess && isIdAvailable))
    }, [pwSuccess,isIdAvailable]);

    const handleCheckId = () => {
        reissue(userId, url, navigate).then(() => {
            if (!user.userId) {
                setIdError('아이디를 입력하세요');
            } else if (user.userId.length < 6) {
                setIdError('아이디는 6자리 이상만 가능합니다.')
            } else {
                axios.get(url + `admin/idcheck`, {
                    headers: {
                        'Authorization': localStorage.getItem('Authorization')
                    },
                    params: {
                        userId: user.userId
                    }
                })
                    .then(response => {
                        if (response.data.code === 200) {
                            setIdError('사용 가능한 아이디입니다.');
                            setIsIdAvailable(true);
                        } else {
                            setIdError('이미 사용중인 아이디 입니다.');
                            setIsIdAvailable(false);
                        }
                    })
                    .catch(error => {
                        console.error('아이디 중복 확인 실패:', error);
                    });
            }
        })
    };

    return (
        <div id="wrapper">
            <Sidebar menuCode={"SET0300"}/>
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <div className="container-fluid">
                        <Header pageName='웹 계정 등록'/>
                        <Card className="card shadow mb-4">
                            <Card.Body style={{margin:'1rem'}}>
                                <p style={{fontSize:'14px',marginBottom:'10px'}} className="before_required">표시는 필수 입력 항목입니다.</p>
                                <Table bordered>
                                    <tbody>
                                    <tr>
                                        <td style={{width: '20%'}} className={styles.tableHead}>
                                            <Form.Label><p className="after_required">아이디</p></Form.Label></td>
                                        <td style={{ width: '80%' }}>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="아이디"
                                                    name="userId"
                                                    value={user.userId}
                                                    onChange={handleIdChange}
                                                />
                                                <button
                                                    onClick={handleCheckId}
                                                    className="btn btn-primary"
                                                    type="button"
                                                    style={{ marginLeft: '1rem' }}
                                                >
                                                    중복확인
                                                </button>
                                                <p style={{ marginLeft: '1rem', marginBottom: 0 }}>
                                                    아이디는 6자리 이상입니다.
                                                </p>
                                            </div>
                                            {idError && <p className="errormessage">{idError}</p>}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className={styles.tableHead}><Form.Label><p className="after_required">비밀번호</p></Form.Label></td>
                                        <td>
                                            <div style={{ display: "flex", alignItems: "flex-start" }}>
                                                <div style={{ display: "flex", flexDirection: "column" }}>
                                                    <Form.Control
                                                        type="password"
                                                        placeholder="비밀번호"
                                                        name="password"
                                                        value={user.password}
                                                        onChange={handleChange}
                                                    />
                                                    {error && <p style={{ marginTop: '4px' }}>{error}</p>}
                                                </div>
                                                <p style={{ marginLeft: '1rem', marginTop: '10px' }}>
                                                    {MESSAGES.PASSWORD.FORMAT}
                                                </p>
                                            </div>
                                        </td>

                                    </tr>
                                    <tr>
                                        <td className={styles.tableHead}><Form.Label><p className="after_required">비밀번호 확인</p></Form.Label></td>
                                        <td>
                                            <Form.Control type="password" placeholder="비밀번호 확인" name="passwdChcek"
                                                          value={passwdCheck} onChange={handlePasswdCheckChange}/>
                                            <p className="errormessage" style={{color: message.color}}>{message.text}</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className={styles.tableHead}><Form.Label><p>이름</p></Form.Label></td>
                                        <td>
                                            <Form.Control placeholder="이름" type="text" name="userName"
                                                          value={user.userName} onChange={handleChange}/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className={styles.tableHead}><Form.Label><p className="after_required">회사명</p></Form.Label></td>
                                        <td>
                                            <Form.Select className="select_box device" value={customerCodeSelected}
                                                         onChange={handleChangeCustomerCodeSelect} name="customerCode">
                                                {customerCode.map(customerCode => (
                                                    <option key={customerCode.customerCode}
                                                            value={customerCode.customerCode}>{customerCode.customerName}</option>
                                                ))}
                                                <option value=''>텔레컨스</option>
                                            </Form.Select>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className={styles.tableHead}><Form.Label><p className="after_required">권한명</p></Form.Label></td>
                                        <td>
                                            <Form.Select className="select_box device" value={authoritySelected}
                                                         onChange={handleChangeAuthoritySelect} name="authority">
                                                {authority.map(authority => (
                                                    <option key={authority.authorityId}
                                                            value={authority.authorityId}>{authority.authorityName}</option>
                                                ))}
                                            </Form.Select>
                                        </td>
                                    </tr>
                                    </tbody>
                                </Table>
                                <div className="btn modify">
                                    <button className="btn btn-primary" disabled={disabled}
                                            onClick={handleSubmit} type="submit">등록
                                    </button>
                                    <button className="btn btn-secondary cancel" onClick={handleCancel}>취소
                                    </button>
                                </div>
                            </Card.Body>
                        </Card>
                    </div>
                </div>
                <Footer/>
            </div>
        </div>
    )
}

export default WebUserAdd;